import { TaxInquiryActions } from './browse.action';
import { TaxTransactionActions } from './transaction.action';

export const taxInquires = {
  namespaced: true,
  state: () => ({
    taxInquiry: [],
    selectedItems: [],
    selectedOverPaymentsItems: [],
    selectedPamentsRecords: [],
    isDialog: false,
    isTaxIdClicked: false,
    transactions: undefined,
    nextTaxIdForSA: undefined,
    nextTaxIdForOmit: undefined,
    taxRateTaxInquiry: null,
    togglePrintOrEmail: false,
    toggleMultiple: false,
  }),
  mutations: {
    setTaxInquiry(state, taxData) {
      state.taxInquiry = taxData;
    },
    setDialog(state, isDialog) {
      state.isDialog = isDialog;
    },
    setSelectedPamentsRecords(state, item) {
      state.selectedPamentsRecords = item;
    },
    setTransaction(state, transactions) {
      state.transactions = transactions;
    },
    setSelectedItems(state, items) {
      state.selectedItems = items;
    },
    setSelectedOverPaymentsItems(state, items) {
      state.selectedOverPaymentsItems = items;
    },
    setIsTaxIdClicked(state, items) {
      state.isTaxIdClicked = items;
    },
    setTaxRateTaxInquiry(state, items) {
      state.taxRateTaxInquiry = items;
    },
    setStats(state, results) {
      if (results.type === 's') state.nextTaxIdForSA = results.max + 1;
      if (results.type === 'o') state.nextTaxIdForOmit = results.max + 1;
    },
    setTogglePrintOrEmail(state, { res }) {
      state.togglePrintOrEmail = res;
    },
    setToggleMultiple(state, value) {
      state.toggleMultiple = value;
    },
    updateTaxInquiryTransactionLocalFileStatus(state, { objectId, status }) {
      /* find in owner list and update the status */
      const key1 = 'ownerTransactionList';
      const result1 = this.getters['base/crud/items'](key1).find(
        (object) => (object._id || '').toString() === (objectId || '').toString(),
      );
      if (result1) {
        result1.hasFiles = status;
      }

      /* find in taxroll list and update the status */
      const key2 = 'TaxrollTransactionList';
      const result2 = this.getters['base/crud/items'](key2).find(
        (object) => (object._id || '').toString() === (objectId || '').toString(),
      );
      if (result2) {
        result2.hasFiles = status;
      }
    },
  },
  getters: {
    getDialog(state) {
      return state.isDialog;
    },
  },
  actions: {
    ...TaxInquiryActions,
    ...TaxTransactionActions,
  },
};

export default taxInquires;
